




























































































































































import { clearRecMaintenanceSavingState } from "@/components/work-buhin/WorkBuhinRecMaintenance";
import { Component, Vue, Watch } from "vue-property-decorator";
import ButtonInspect from "@/components/common/button/ButtonInspect.vue";
import ButtonInspectGroup from "@/components/common/button/ButtonInspectGroup.vue";
import {
  InspectRecommend,
  InspectRecommendCategory,
  InspectRecommendSubItem
} from "@/model/InspectRecommend";
import { InspectService } from "@/service/inspectService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { InspectButtonStatus } from "@/model/InspectButtonStatus";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { Getter, Action } from "vuex-class";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import { Utils } from "@/service/util";
import WorkAndBuhin from "@/components/WorkAndBuhin.vue";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { INSPECT_TYPE } from "@/model/InspectType";
import { RouteInfo } from "@/model/RouteInfo";
import { SocketControllers } from "@/service/SocketControllers";
import NextageFooter from "@/components/nextageFooter.vue";
import { WORK_AND_BUHIN_MODE, WorkAndBuhinMode } from "@/model/WorkAndBuhinData";
import { RecMaintenancePageService } from "@/service/RecMaintenancePageService";

// refactor : 現状はmodel式。serviceにはなっていない
import * as RecMaintenancePageServiceModel from "@/model/RecMaintenancePageService";

const namespaceInspect = "Inspect";
@Component({
  components: {
    ButtonInspect,
    ButtonInspectGroup,
    InputNumber,
    SaveDialog,
    ConfirmDialog,
    WorkAndBuhin
    , NextageFooter
  }
})
export default class RecommendMaintenance extends Vue {
  data: InspectRecommend = {};
  service: InspectService;
  ippanSeibiService: IppanSeibiService;
  pageService: RecMaintenancePageServiceModel.RecMaintenancePageService;
  sktControll: SocketControllers;
  activeCategory: number = 0;
  currentData: InspectRecommendSubItem[] = [];
  loadData: boolean = false;
  errorMsg: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  timerSave: any = null;
  timerClick: any;
  tempInspect: InspectRecommendSubItem;
  tempIndex: number = -1;
  activeInspect: any = {};
  msgAskChangeInspectResult: string = MESSAGE.AskChangeInspectResult;
  tempListSave: InspectRecommendSubItem[] = [];
  arrStatus: number[] = [];
  isSaving: boolean = false;
  recommendSaveRevision: number = 0;
  tempWaitSave: any = [];
  qmMitsumori: any = {};
  seibiNm: string = "";
  kouchinZn: any = null;
  kouchinZk: any = null;
  kingakuFlg: boolean = false;
  maxRowNum: number = 0;
  isSocket: boolean = false;

  isExitConnectSocket: boolean = false;

  public utils: Utils = new Utils();

  $refs!: {
    buttonGroup: ButtonInspectGroup[];
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    confirmDialog: ConfirmDialog;
    confirmRegisterDialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
  };

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("recommend", { namespace: namespaceInspect })
  recommend: InspectRecommend;
  @Getter("hasRecommendData", { namespace: namespaceInspect })
  hasData: boolean;

  @Action("setInspectRecommend", { namespace: namespaceInspect })
  setInspect: any;
  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
  @Getter("currentState", { namespace: "FunctionSetting" })
  functionSettingState: any;
  /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */

  /** 2021-07-30 sh #6989 implements quick mitsumori. [START] */
  @Action("setState", { namespace: "QuickMitsumoriQrInfo" })
  setStateQuickMitsumoriQrInfo: any;
  /** 2021-07-30 sh #6989 implements quick mitsumori. [END] */

  /** 2021-11-24 sh #7530 improve speed.(for back) [START] */
  @Getter("currentState", { namespace: "RouteState" })
  lastSelectedCategoryInfo!: (index: number) => RouteInfo;
  @Getter("hasState", { namespace: "RouteState" })
  hasLastSelectedCategoryInfo!: (index: number) => boolean;

  @Action("setState", { namespace: "RouteState" })
  setRouteInfo: any;
  /** 2021-11-24 sh #7530 improve speed.(for back) [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */
  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.socketEntry("updateCourseSubscription",this.getInitData); // catchSocket:08車検コース変更による再描画指示
    this.sktControll.connectSocket();
  }

  created() {
    this.pageService = new RecMaintenancePageService();
    this.service = new InspectService();
    this.ippanSeibiService = new IppanSeibiService();
    this.$emit("onactivepage", this.$route.name);

    // if (this.hasData) {
    //   this.data = this.recommend;
    //   this.setCurrentData();
    //   this.loadData = true;
    // } else {
    /** [START] for quick mitsumori */
    // this.reqService.getInspectRecommend(this.uketsukeExtendsId).then(
    //  (res: InspectRecommend) => {
    //    if (res) {
    //      this.setProgressState({
    //        stateId: res.sknWorkProgressStateId,
    //        stateNm: res.sknWorkProgressStateNm
    //      });
    //      this.initData(res);
    //    }
    //  },
    //  (err: any) => {
    //    this.loadData = true;
    //    this.onError(err);
    //  }
    // );
    this.getInitData();
    /** [END] for quick mitsumori */
    // }

    this.connectSocket();
  }

  getInitData() {
    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
    this.loadData = false;
    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */
    this.pageService.getInspectRecommend(this.uketsukeExtendsId).then(
      (res: any) => {
        if (res) {
          this.setProgressState({
            stateId: res.sknWorkProgressStateId,
            stateNm: res.sknWorkProgressStateNm
          });
          this.initData(res);
        }
      },
      (err: any) => {
        this.loadData = true;
        this.onError(err);
      }
    );
  }

  initData(res: any) {
    const revision = this.recommendSaveRevision;
    const initialState = this.pageService.buildInitialDataState(
      res,
      this.changeStatus.bind(this),
      this.setCateStatus.bind(this),
      this.maxRowNum
    );
    if (initialState.hasRecommend) {
      this.maxRowNum = initialState.maxRowNum;
      /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
      // Promise.all(promise).then((val: any) => {
      //   this.data = { recommend : val };
      //   this.setInspect(this.data);
      //   this.setCurrentData();
      // });
      const pmQmMitsumoriPreview = this.getQmMitsumoriPreviewPM();
      Promise.all([initialState.categories, pmQmMitsumoriPreview]).then((val: any) => {
        if (revision !== this.recommendSaveRevision || this.isSaving ||
            this.timerSave || this.activeInspect.showWork) {
          return;
        }
        if (val.length > 0) {
          this.data = initialState.data;
          this.setInspect(this.data);
          this.setCurrentData();

          /** 2021-11-24 sh #7530 improve speed. (for back) [START] */
          this.changeCategoryByLastSelected(val[0].length);
          /** 2021-11-24 sh #7530 improve speed. (for back) [END] */
        }
        if (val.length > 1) {
          this.qmMitsumori = val[1];
          // console.log("recMaintenance.initData pmQmMitsumoriPreview => ", this.qmMitsumori);
          /** 2021-07-30 sh #6989 implements quick mitsumori. [START] */
          this.setStateQuickMitsumoriQrInfo(val[1]);
          /** 2021-07-30 sh #6989 implements quick mitsumori. [END] */
        }
      });
      /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
    }
  }

  setCurrentData() {
    if (this.isSaving) {
      return;
    }
    this.loadData = true;
    const currentDataState = this.pageService.buildCurrentDataApplyState({
      data: this.data,
      activeCategory: this.activeCategory
    });
    if (currentDataState.hasCategory) {
      this.kingakuFlg = currentDataState.kingakuFlg;
      /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [START] */
      this.currentData = []; // 一旦空にする
      /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [END] */
      Promise.all(currentDataState.currentData).then(vals => {
        vals.map((val: any, i: number) => {
          this.$set(this.currentData, i, this.utils.deepCopy(val));
        });
      });
    }
  }

  onCheckAll(data: { isActive: boolean; value: number }) {
    const btnIndex = this.service.findIndexOnScreen();
    let nChange = 0;
    for (let i = btnIndex.start; i <= btnIndex.end; i++) {
      let buttongroup = this.$refs.buttonGroup[i] as ButtonInspectGroup;
      if (!this.isDuplicate(this.currentData[i])) {
        const isChange = buttongroup.setActive({
          isActive: data.isActive,
          value: data.value,
          isAll: true
        });
        if (isChange) {
          nChange++;
        }
      }
    }
    if (nChange > 0) {
      this.saveCurrentData();
    }
    // this.saveAfterClick();
  }

  onInspectBtnChange(value: number, item: InspectRecommendSubItem) {
    const isDup = this.isDuplicate(item);
    if (!isDup) {
      this.service.setInspectResultRecomend2(value, item);
      this.changeStatus(item);
    }
  }

  changeStatus(item: InspectRecommendSubItem, checkCate?: boolean) {
    this.service.changeStatusRecommendSeibi2(item);
    if (checkCate !== false) {
      this.changeCateStatus();
    }
  }

  changeCateStatus() {
    const statusInput = this.pageService.buildCategoryStatusApplyState(
      this.currentData
    );
    this.setCateStatus(statusInput.sumStatus, statusInput.nItem);
  }

  setCateStatus(
    sumStatus: number,
    nItem: number,
    cate?: InspectRecommendCategory
  ) {
    if (cate == null && this.data.recommend) {
      cate = this.data.recommend[this.activeCategory];
    }
    if (cate) {
      cate.status = this.pageService.resolveCategoryStatus({
        sumStatus,
        nItem
      });
    }
  }

  // onRadioClick(item: InspectRecommendSubItem) {
  //   if (item.usePart != "0") {
  //     item.usePart = "0";
  //     this.onRadioChange(item);
  //   }
  // }

  // onRadioChange(item: InspectRecommendSubItem) {
  //   this.service.changeUsePart(item);
  //   this.changeStatus(item);
  // }

  isActive(i: number) {
    return this.activeCategory == i;
  }

  changeCategory(i: number) {
    this.activeCategory = i;
    this.currentData = [];
    this.kingakuFlg = false;
    this.$nextTick(() => {
      this.setCurrentData();
    });
    /** 2021-11-24 sh #7530 improve speed. (for back) [START] */
    /** ここで、カテゴリ情報を覚えておく。backして戻ったときに、最後のカテゴリを開くため */
    let routeInfo: RouteInfo = this.pageService.buildRouteInfo(
      this.data.recommend,
      i
    );
    this.setRouteInfo({ data: routeInfo, index: INSPECT_TYPE.RECOMMEND });
    /** 2021-11-24 sh #7530 improve speed. (for back) [END] */
  }

  isDuplicate(item: InspectRecommendSubItem) {
    return item.isInspectDuplicate == 1;
  }

  isDisabled(item: InspectRecommendSubItem) {
    return this.pageService.isWorkDisabled(item);
  }

  isComplete(item: any) {
    return this.service.isComplete(item);
  }

  isIncomplete(item: any) {
    return this.service.isIncomplete(item);
  }

  isStatusNone(item: InspectRecommendSubItem) {
    return this.service.isStatusNone(item);
  }

  goTop() {
    let wrap = document.querySelector(".select-item-wrap");
    if (wrap) {
      wrap.scrollTop = 0;
    }
  }

  // saveData() {
  //   let objForSave = JSON.parse(JSON.stringify(this.data));
  //   objForSave.recommend.forEach((cate: InspectRecommendCategory) => {
  //     delete cate.status;
  //     cate.subItems.forEach((obj: InspectRecommendSubItem) => {
  //       delete obj.status;
  //       delete obj.showWork;
  //     });
  //   });
  //   return this.reqService.saveInspectRecommend(objForSave);
  // }

  saveCurrentData() {
    this.currentData.forEach(seibi => {
      seibi.isSaving = true;
    });
    const data = this.pageService.buildCurrentDataSavePayload({
      currentData: this.utils.deepCopy(this.currentData),
      data: this.data,
      activeCategory: this.activeCategory,
      uketsukeExtendsId: this.uketsukeExtendsId
    });
    if (data) {
      this.saveAndUpdateData(data, true);
    }
  }

  getIsSocket() {
    /** 2024-01-24 sh #8725(BQRxxx) お奨め整備の金額が赤画面に反映されない (No.5) [START] */
    // return this.arrStatus.indexOf(InspectButtonStatus.COMPLETED) > -1 ? 1 : 0;
    return this.pageService.resolveSocketFlag({
      arrStatus: this.arrStatus,
      activeInspect: this.activeInspect
    });
    /** 2024-01-24 sh #8725(BQRxxx) お奨め整備の金額が赤画面に反映されない (No.5) [END] */
  }

  getObjForSave(item: any = null) {
    return this.pageService.buildSavePayload({
      item,
      tempListSave: this.utils.deepCopy(this.tempListSave),
      data: this.data,
      activeCategory: this.activeCategory,
      uketsukeExtendsId: this.uketsukeExtendsId,
      isSocket: this.getIsSocket()
    });
  }

  findSeibiIndex(list: any, seibiSave: any) {
    return this.pageService.findSeibiIndex(list, seibiSave);
  }

  saveSeibiItem(inspectItem: InspectRecommendSubItem) {
    this.recommendSaveRevision++;
    inspectItem.isSaving = true;
    if (this.data.recommend) {
      this.service.autoSetSameRecommendSeibi(this.data.recommend, inspectItem);
    }
    // if (inspectItem.status == InspectButtonStatus.COMPLETED) {
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    // if (
    //   inspectItem.inspectResult == InspectButtonValue.CIRCLE &&
    //   inspectItem.manualBuhinList.length > 0
    // ) {
    //   inspectItem.manualBuhinList.forEach(buhin => {
    //     if (buhin.buhinId) {
    //       this.reqService.deleteManualBuhin(buhin.buhinId);
    //     }
    //   });
    // }
    const saveItemState = this.pageService.buildSaveQueueItemWithCategory({
      inspectItem,
      data: this.data,
      activeCategory: this.activeCategory
    });
    let objForSave: InspectRecommendSubItem = saveItemState.item;
    this.arrStatus.push(saveItemState.status);
    if (objForSave.buhinSelected === STATUS_SELECT_WORK_BUHIN.Initial) {
      objForSave.buhinList = this.service.removeDefualtBuhin(
        objForSave.buhinList
      );
      if (objForSave.osusumeBuhinList) {
        objForSave.osusumeBuhinList = this.service.removeDefualtBuhin(
          objForSave.osusumeBuhinList
        );
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
        objForSave.osusumeBuhinList =
          this.pageService.buildOsusumeBuhinListForSave(
            objForSave.osusumeBuhinList
          );
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      }
    }
    if (this.isSaving) {
      this.tempWaitSave = this.pageService.upsertSaveQueue(
        this.tempWaitSave,
        objForSave
      );
    } else {
      this.tempListSave = this.pageService.upsertSaveQueue(
        this.tempListSave,
        objForSave
      );
      this.timerSave = setTimeout(() => {
        this.timerSave = null;
        if (this.tempListSave.length > 0) {
          const data = this.getObjForSave();
          this.saveAndUpdateData(data);
        }
      }, 1000);
    }
  }

  saveBuhin(inspectItem: InspectRecommendSubItem) {
    // 確定時は画面内に保持し、閉じる時に最新内容を保存キューへ渡す。
    this.recommendSaveRevision++;
    if (this.data.recommend) {
      this.service.autoSetSameRecommendSeibi(this.data.recommend, inspectItem);
    }
  }

  saveAndUpdateData(data: any, isUpdateAll: boolean = false) {
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    this.isSaving = true;
    this.recommendSaveRevision++;
    this.tempListSave = [];
    this.arrStatus = [];
    this.pageService.saveInspectRecommend(data).then(
      (res: any) => {
        if (res.status == 200 && res.body) {
          this.isSocket = true;
          this.finishRecommendSave(data);
          if (!this.isSaving) {
            this.initData(res.body);
          }
        } else {
          this.finishRecommendSave(data);
        }
      },
      error => {
        console.error("error", error.rsltComment);
        this.finishRecommendSave(data);
      }
    );
  }

  finishRecommendSave(data: any) {
    const pendingItems = this.utils.deepCopy(this.tempWaitSave || []);
    this.currentData = clearRecMaintenanceSavingState({
      currentData: this.currentData,
      savePayload: data,
      pendingItems
    });
    this.tempWaitSave = [];
    this.isSaving = false;
    if (pendingItems.length > 0) {
      this.saveAndUpdateData(this.getObjForSave(pendingItems));
    }
  }

  onError(res: any) {
    this.loading = false;
    this.errorMsg = this.utils.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  onSave() {
    // this.loading = true;
    // this.saveData().then(
    //   res => {
    //     this.loading = false;
    this.$emit("saveSpentTime");
    this.$refs.saveDialog.onOpen();
    //   },
    //   (res: any) => {
    //     this.onError(res);
    //   }
    // );
  }

  onRegister() {
    this.$emit("saveSpentTime");
    // let status = this.service.getRegisterStatus(this.data.recommend);
    // this.$emit("onregister", { pageName: this.$route.name, status });
    this.$emit("onregister", { pageName: this.$route.name });
  }

  goNextCate() {
    if (
      this.data.recommend &&
      this.activeCategory < this.data.recommend.length - 1
    ) {
      this.activeCategory++;
      this.changeCategory(this.activeCategory);
    }
  }

  goBackCate() {
    if (this.activeCategory > 0) {
      this.activeCategory--;
      this.changeCategory(this.activeCategory);
    }
  }

  get showBtnBack() {
    if (this.activeCategory > 0) {
      return true;
    }
    return false;
  }

  get backCate() {
    if (this.showBtnBack && this.data.recommend) {
      return this.data.recommend[this.activeCategory - 1]
        .sknRecommendInspectCategoryNm;
    }
    return "";
  }

  get showBtnNext() {
    if (
      this.data.recommend &&
      this.activeCategory < this.data.recommend.length - 1
    ) {
      return true;
    }
    return false;
  }

  get nextCate() {
    if (this.showBtnNext && this.data.recommend) {
      return this.data.recommend[this.activeCategory + 1]
        .sknRecommendInspectCategoryNm;
    }
    return "";
  }

  // saveAfterClick() {
  //   if (this.timerSave) {
  //     clearTimeout(this.timerSave);
  //   }
  //   this.timerSave = setTimeout(() => {
  //     this.saveData();
  //   }, 1000);
  // }

  showWork(event: any, item: any) {
    if (item.isSaving) {
      return;
    }
    this.recommendSaveRevision++;
    const toggleState = this.pageService.buildWorkToggleApplyState(item);
    item.showWork = toggleState.showWork;
    this.activeInspect = toggleState.activeInspect;
  }

  resetBtnPriotity(index: number) {
    let buttongroup = this.$refs.buttonGroup[index] as ButtonInspectGroup;
    buttongroup.setActive({
      isActive: true,
      value: 0,
      isAll: false
    });
  }

  deleteAlManualBuhin(item: any) {
    const deleteState = this.pageService.buildManualBuhinDeleteApplyState(item);
    if (deleteState.shouldClear) {
      const manualBuhinList = this.utils.deepCopy(deleteState.manualBuhinList);
      item.manualBuhinList = [];
      manualBuhinList.forEach((buhin: any) => {
        if (buhin.id) {
          this.pageService.deleteManualBuhin(buhin.id);
        }
      });
    }
  }

  onChangeShow(item: any, index: number) {
    const changeShowState = this.pageService.buildChangeShowApplyState(item);
    if (changeShowState.action === "error") {
      this.errorMsg = "現車確認又は57項目点検で関連する点検項目が「×」になっている為解除できません。";
      this.$refs.errorDialog.onOpen();
    } else if (changeShowState.action === "save") {
      Object.assign(item, changeShowState.itemState);
      // this.resetBtnPriotity(index);
      this.activeInspect = changeShowState.activeInspect;
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeStatus(item);
      this.saveSeibiItem(item);
    } else {
      this.askConfirmChange(item, index);
    }
  }

  onConfirmChangeInspect() {
    const confirmChangeState = this.pageService.buildConfirmChangeApplyState(
      this.tempInspect
    );
    this.arrStatus.push(confirmChangeState.status);
    this.activeInspect = confirmChangeState.activeInspect;
    Object.assign(this.tempInspect, confirmChangeState.itemState);
    // this.resetBtnPriotity(this.tempIndex);
    this.service.setInspectResultRecomend2(0, this.tempInspect);
    if (confirmChangeState.shouldClearBuhin) {
      this.deleteAlManualBuhin(this.tempInspect);
      this.service.deletAllBuhinInSeibi([this.tempInspect]);
    }
    this.changeStatus(this.tempInspect);
    this.saveSeibiItem(this.tempInspect);
    this.$refs.confirmDialog.onClose();
  }

  onCancelChangeInspect() {
    this.$refs.confirmDialog.onClose();
  }

  askConfirmChange(item: InspectRecommendSubItem, index: number) {
    this.$refs.confirmDialog.onOpen();
    this.tempInspect = item;
    this.tempIndex = index;
  }

  onConfirmBuhin(item: InspectRecommendSubItem) {
    const confirmItem = this.pageService.resolveConfirmItem(item);
    this.changeStatus(confirmItem);
    this.saveBuhin(confirmItem);
  }

  buttonLabel(inspect: any) {
    return this.pageService.getWorkButtonLabel(inspect);
  }

  hasValueWork(inspect: any) {
    return this.pageService.getWorkButtonClass(inspect, this.isIncomplete(inspect));
  }

  isShow(inspect: any) {
    return this.pageService.getShowButtonClass(inspect);
  }

  isShowAll(show: number) {
    return this.pageService.isShowAll(this.currentData, show);
  }

  showAll() {
    if (this.isShowAll(1)) {
      return;
    }
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    this.currentData.forEach((item: any) => {
      Object.assign(item, this.pageService.buildShowAllItemApplyState(item).state);
    // this.currentData.forEach(item => {
    //  item.osusumeIsShow = 1;
      // if (!item.osusumeBuhinList || (item.osusumeBuhinList && item.osusumeBuhinList.length == 0)) {
      //   item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      // }
      /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeStatus(item);
    });
    this.saveCurrentData();
  }

  hideAll() {
    if (this.isShowAll(0)) {
      return;
    }
    this.currentData.forEach((item, i) => {
      const hideState = this.pageService.buildHideAllItemApplyState(item);
      if (hideState.shouldUpdate) {
        Object.assign(item, hideState.state);
        this.service.setInspectResultRecomend2(item.inspectResult, item);
        // this.resetBtnPriotity(i);
        this.deleteAlManualBuhin(item);
        this.service.deletAllBuhinInSeibi([item]);
      }
    });
    this.saveCurrentData();
  }

  beforeDestroy() {
    if (this.timerSave) {
      /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
      // this.reqService.saveInspectRecommend(this.getObjForSave());
      if (this.pageService.shouldSaveBeforeDestroy({
        timerSave: this.timerSave,
        tempListSave: this.tempListSave,
        routeName: this.$route.name
      })) {
        // sendSocket:ソケット仮22
        // sendSocket:ソケット仮06
        this.pageService.saveInspectRecommend(this.getObjForSave());
      }
      /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    if (Object.keys(this.activeInspect).length > 0) {
      this.activeInspect.showWork = false;
    }
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.pageService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      this.$router.push({ name: "reservation" });
    });
  }

  /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
  getQmMitsumoriPreviewPM() {
    const promise = new Promise((resolve, reject) => {
      this.pageService.getQmMitsumoriPreview(this.uketsukeExtendsId).then((res: any) => {
        resolve(res);
      }, error => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
        reject();
      });
    });
    return promise;
  }

  get checkQmMitsumoriBtn() {
    if (this.functionSettingState && this.functionSettingState.isCanUseQuickMitsumori === 1) {
      if (this.uketsukeExtendsId && this.qmMitsumori
        && this.qmMitsumori.isCanUseQuickMitsumori === 1
        && this.qmMitsumori.isHasQuickMitsumori === 1) {
        return true;
      }
    }
    return false;
  }
  /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
  addcurrentData() {
    if (this.seibiNm.length > 0) {
      /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [START] */
      let item = this.pageService.buildManualAddItem({
        uketsukeExtendsId: this.uketsukeExtendsId,
        seibiNm: this.seibiNm,
        kouchinZn: this.kouchinZn,
        data: this.data,
        activeCategory: this.activeCategory
      });
      /** 2021-07-02 sh #7257 it does not work that change teian-suru to shiani. [END] */
      this.arrStatus.push(InspectButtonStatus.COMPLETED);
      this.saveManualItem(item);
    }
  }

  saveManualItem(item: any) {
    this.activeInspect = item;
    /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [START] */
    this.isSaving = true;
    /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [END] */
    // sendSocket:ソケット仮22
    // sendSocket:ソケット仮06
    this.pageService.saveInspectRecommendManual(this.getObjForSave(item)).then(
      (res: any) => {
        if (res.status == 200 && res.body) {
          const addSuccessState = this.pageService.buildManualItemAddSuccessState({
            uketsukeExtendsId: this.uketsukeExtendsId,
            seibiId: res.body,
            seibiNm: this.seibiNm,
            kouchinZn: this.kouchinZn,
            data: this.data,
            activeCategory: this.activeCategory,
            rowNum: this.currentData.length
          });
          this.currentData.push(addSuccessState.item);
          if (this.data && this.data.recommend && this.data.recommend.length > 0 
              && this.data.recommend[this.activeCategory].subItems 
              && this.data.recommend[this.activeCategory].subItems.length > 0
          ) {
            this.data.recommend[this.activeCategory].subItems.push(addSuccessState.item);
          }
          this.seibiNm = addSuccessState.seibiNm;
          this.kouchinZn = addSuccessState.kouchinZn;
          this.kingakuFlg = addSuccessState.kingakuFlg;
        }
        /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [START] */
        this.isSaving = false;
        /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [END] */
      },
      error => {
        console.error("error", error);
        /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [START] */
        this.isSaving = false;
        /** 2023-04-21 sh #8188(BQR1084) fix bug. it does not work when manual seibi. [END] */
      }
    );
  }

  onCloseBuhin(event: {
    isChange: boolean;
    isResetSeibi: boolean;
    isSocket: boolean;
  }) {
    const closeState = this.pageService.buildCloseApplyState(event, this.activeInspect);
    if (closeState.shouldSave) {
      this.applyRecMaintenanceCloseState(closeState);
      this.changeStatus(closeState.activeInspect);
      this.saveSeibiItem(closeState.activeInspect);
    }
    this.$set(this, "activeInspect", {});
  }

  applyRecMaintenanceCloseState(
    closeState: RecMaintenancePageServiceModel.RecMaintenanceCloseApplyState
  ) {
    this.isSocket = closeState.isSocket;
  }

  /** 2021-11-24 sh #7530 improve speed.(for back) [START] */
  hasLastSelectedCategoryId() {
    return this.hasLastSelectedCategoryInfo(INSPECT_TYPE.RECOMMEND);
  }

  getLastSelectedCategoryId() {
    let sknInspectCategoryId: any;
    if (this.hasLastSelectedCategoryId()) {
      let lastCategoryInfo: RouteInfo = this.lastSelectedCategoryInfo(INSPECT_TYPE.RECOMMEND);
      if (lastCategoryInfo && lastCategoryInfo.sknInspectCategoryId) {
        sknInspectCategoryId = lastCategoryInfo.sknInspectCategoryId;
      }
    }
    return sknInspectCategoryId;
  }

  getLastSelectedPos() {
    const lastCategoryInfo: any = this.hasLastSelectedCategoryId()
      ? this.lastSelectedCategoryInfo(INSPECT_TYPE.RECOMMEND)
      : null;
    return this.pageService.resolveLastSelectedPos({
      hasLastSelectedCategoryId: this.hasLastSelectedCategoryId(),
      lastCategoryInfo
    });
  }

  posToSknInspectCategoryId(pos: any) {
    return this.pageService.buildRouteInfo(this.data.recommend, Number(pos))
      .sknInspectCategoryId;
  }

  changeCategoryByLastSelected(length: number) {
    const lastCategoryInfo: any = this.hasLastSelectedCategoryId()
      ? this.lastSelectedCategoryInfo(INSPECT_TYPE.RECOMMEND)
      : null;
    const pos = this.pageService.resolveCategoryRestorePos({
      hasLastSelectedCategoryId: this.hasLastSelectedCategoryId(),
      lastCategoryInfo,
      length
    });
    if (pos > -1) {
      this.changeCategory(pos);
    }
  }
  /** 2021-11-24 sh #7530 improve speed.(for back) [END] */

  /** 2022-01-27 sh #7676(BQR061) add condition of tooltip. [START] */
  tooltipMessage(child: any) {
    return this.pageService.getTooltipMessage(this.isDuplicate(child));
  }

  get workAndBuhinMode(): WorkAndBuhinMode {
    return WORK_AND_BUHIN_MODE.RECOMMEND;
  }
  /** 2022-01-27 sh #7676(BQR061) add condition of tooltip. [END] */
}
